const ValueCheckers = {
  undefined: value => value === undefined,
  defined: value => Boolean(value),
  positive: value => value && value > 0,
  positiveOrZero: value => (value !== undefined) && value >= 0,
  negative: value => value && value < 0,
  negativeOrZero: value => (value !== undefined) && value <= 0,
  zeroOrUndefined: value => value === undefined || value === 0,
  falsy: value => !value,
};

const propertyAccessor = (propName, properties) => {
  const property = properties && properties[propName];
  if (property && property.getValue) {
    return properties.getValue;
  }
  if (propName.indexOf('.') > 0) {
    const propArray = propName.split('.');
    const useProps = propArray.length && (propArray[0] === '[props]');
    const start = useProps ? 1 : 0;
    return (object, props) => {
      let value = useProps ? props : object;
      for (let i = start; i < propArray.length; i += 1) {
        if (!value) return undefined;
        value = value[propArray[i]];
      }
      return value;
    };
  }
  return object => object[propName];
};

const Condition = (config, properties, viewService) => {
  if (config.and) {
    const childEvaluators = config.and.map((c) => {
      return Condition(c, properties, viewService);
    });
    return (object, props) => {
      const falsy = childEvaluators.find((evaluator) => {
        return !evaluator(object, props);
      });
      return !falsy;
    };
  }
  if (config.or) {
    const childEvaluators = config.or.map((c) => {
      return Condition(c, properties, viewService);
    });
    return (object, props) => {
      const firstTyue = childEvaluators.find((evaluator) => {
        return evaluator(object, props);
      });
      return !!firstTyue;
    };
  }
  if (config.not) {
    const childEvaluator = Condition(config.not, properties, viewService);
    return (object, props) => {
      return !childEvaluator(object, props);
    };
  }
  // Property evaluator
  const propName = Object.keys(config)[0];
  const ValueChecker = ValueCheckers[config[propName]] || (value => value === config[propName]);
  const getValue = propertyAccessor(propName, properties);
  return (object, props) => {
    const value = getValue(object, props);
    return ValueChecker(value);
  };
};

export { Condition as default, ValueCheckers };
